import React from 'react';
import PropTypes from 'prop-types';
import { setHelmetTags } from 'helpers/HelmetHelper';

const Seo = ({ seo }) => <>{setHelmetTags(seo)}</>;

Seo.propTypes = {
  seo: PropTypes.shape({}),
};

export default Seo;
